<template>
    <div class="basic_wrap">
        <div class="top_nav">
            <van-icon name="arrow-left" class="back_icon" @click="$router.back()" />
            <div class="nav_title">{{$t('notice.detail')}}</div>
        </div>
        
        <div class="main_content">
            <div class="m-card msg_box">
                <div class="tit">
                    <p class="tips">{{data[title]}}</p>
                    <p class="time">{{data.add_time}}</p>
                </div>
                <div class="contract_box" style="width: 100%" v-html="data[content]"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import Fetch from "../../utils/fetch";

    export default {
        name: "notice_article",
        data() {
            return {
				title:"title_"+ (this.$i18n.locale||"zh_cn"),
				content:"content_"+ (this.$i18n.locale||"zh_cn"),
                data: {},
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.start();
        },
        methods: {
            start() {
                Fetch('/user/notice_view', {
                    id: this.$router.history.current.params.id
                }).then(res => {
                    this.data = res.data.view;
                })
            },
        }
    };
</script>

<style lang="less" scoped>
    .basic_wrap {
        background-color: #F1F4F6;
        min-height: 100vh;
        padding-bottom: 20px;
    }

    .top_nav {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 46px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 100;
        box-shadow: 0 2px 10px rgba(0,0,0,0.05);
        
        .back_icon {
            position: absolute;
            left: 15px;
            font-size: 20px;
            color: #333;
            cursor: pointer;
        }
        
        .nav_title {
            font-size: 16px;
            font-weight: bold;
            color: #333;
        }
    }

    .main_content {
        padding: 61px 15px 15px;
    }

    .m-card {
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.02);
        padding: 20px;
    }

	.msg_box {
        min-height: calc(100vh - 100px);

		.tit {
			margin-bottom: 20px;
            padding-bottom: 15px;
            border-bottom: 1px solid #f5f5f5;
            
			.tips {
				font-size: 18px;
				line-height: 1.4;
				color: #333;
				font-weight: bold;
                margin-bottom: 10px;
                text-align: center;
			}
			.time {
				font-size: 12px;
				color: #999;
                text-align: center;
			}
		}

        .contract_box {
            font-size: 14px;
            color: #444;
            line-height: 1.8;
            word-wrap: break-word;
            
            /deep/ img {
                max-width: 100% !important;
                height: auto !important;
                border-radius: 8px;
                margin: 10px 0;
            }
            
            /deep/ p {
                margin-bottom: 10px;
            }
        }
	}
</style>